const About=()=>{
    return(
        <div className="bg-gray-200 p-2 " >
            <h2 className="text-3xl  font-bold m-6 border-b-8 border-red-500 p-4 w-auto">About me</h2>
            <p className="text-xl ml-6 p-6 text-gray-700">
                I'm a tech enthusiast who spends his days playing around with new technologies in web development and tech in general. Football, science, pop culture and music are some of the things that catch my attention. I love to work on web and hybrid mobile applications. Technology drives and inspires me to keep achieving my goals and help me reach my milestones. A strong believer in 'Leading without a title' philosophy , I play my role with utmost sincerity. I also have a weird sense of humor and I love to crack silly jokes all the time.
            </p>
            <p className="text-xl ml-6 p-6 font-semibold text-gray-700">Currently enjoying working at GeekyAnts India Pvt. Ltd.</p>

        </div>
    )
}
export default About